import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'errors',
    loadChildren: () => import('./errors/routes')
  },
  {
    path: '',
    loadChildren: () => import('./acloud/routes')
  },
  {
    path: '**',
    loadChildren: () => import('./errors/routes')
  },
];
